import axios from 'axios';
import { Gizmo } from '../../../gizmos';
import { IGizmo, IGizmoData, IUserV2 } from '../../../types';

interface IParams {
  data: IGizmoData;
  fid?: string;
  formId?: string;
  filledFormId?: string;
  answerIndex?: string;
  context: {
    gizmo: Gizmo;
  };
}

/**
 * Download a file directly from s3
 *
 * @returns
 */
function downloadFileS3({
  data,
  fid,
  formId,
  filledFormId,
  answerIndex,
  context,
}: IParams): Promise<File | undefined> {
  return new Promise<File | undefined>(async resolve => {
    const { gizmo } = context;
    const user: IUserV2 | undefined = gizmo.getDao()?.getUser();
    const apiUrl: string | undefined = gizmo.getDao()?.getApiUrl();
    const callbacks = gizmo.getCallbacks();
    const config: IGizmo = gizmo.getConfig();

    if (!formId) {
      formId = callbacks.getInfoCB({ type: 'rootGizmoFid' });
    }
    if (!filledFormId) {
      filledFormId = callbacks.getInfoCB({ type: 'rootGizmoDataFid' });
    }
    const fId = fid || config.fid;
    if (answerIndex === undefined) {
      answerIndex = '0';
    }
    const attachmentId = data.fd?.attachmentId || data.id?.attachmentId;
    let extension = data.fd?.fileExtension || data.id?.fileExtension || 'jpg';

    if (apiUrl && user) {
      const credentials: any = user.credentials;
      let url = `${apiUrl}/main_api/v1/files/root_gizmo_data/url?`;
      url += `attachmentId=${attachmentId}&formId=${formId}&filledFormId=${filledFormId}&`;
      url += `fId=${fId}&answerIndex=${answerIndex}&extension=${extension}`;

      try {
        extension = extension.toLowerCase()

        const response = await axios({
          method: 'GET',
          url,
          headers: {
            ...credentials,
          },
        });

        if (response.status === 200) {
          const { data } = response;

          if (data && data.presigned_url) {
            const presignedUrl = data.presigned_url;
            const responseFile = await axios({
              method: 'GET',
              url: presignedUrl,
              responseType: 'blob',
            });

            if (responseFile.status === 200) {
              const { data } = responseFile;
              let type = '';
              if (extension === 'pdf') {
                type = 'application/pdf';
              } else if (extension === 'jpg' || extension === 'jpeg') {
                type = 'image/jpeg';
              } else if (extension === 'png') {
                type = 'image/png';
              }

              const file = new File([data], `${attachmentId}.${extension}`, {
                type,
              });
              return resolve(file);
            }
          }
        }
        return resolve(undefined);
      } catch (e) {
        console.log('-------------------> error: ', e);
      }
    }

    resolve(undefined);
  });
}

export default downloadFileS3;
